import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";

export function UsdtPlans({ analystId }) {
  const [plans, setPlans] = useState([]);
  useEffect(() => { client.get("/billing/products", { params: { analyst_id: analystId } }).then((r) => setPlans(r.data)).catch(() => {}); }, [analystId]);
  if (!plans.length) return null;
  return (
    <div className="mt-2 flex flex-col gap-1" data-testid="usdt-plans">
      {plans.map((p) => (
        <Link key={p.id} to={`/checkout/${p.id}`} data-testid={`usdt-plan-${p.id}`} className="text-xs text-[#ccff00] hover:underline">
          Or pay ${p.price_usd} in USDT · {p.period_days} days
        </Link>
      ))}
    </div>
  );
}
